import React, { useState, useEffect, useContext } from "react";
import { CartContext } from "../cart/cart";
import { Link, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import Navbar from "../navbar/navbar";
import { fetchProducts, fetchCategories,updateAuthor, BASE_URL } from "../utils/utils"; // Import your fetchProducts function from apiUtils
import { AuthContext } from "../authmanager/authcontext";
import ErrorNotification from "../validators/errornotification";
import ProductDescription from "../validators/descriptor";
import { AuthorForm,AuthorProductUploadForm } from "../author/author";
import { Button } from "../button";
const Home = ({ toggleTheme }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { isLoggedIn, handleLogout, backHomeClick, updateTrends } =
    useContext(AuthContext);
  const isAuthor = localStorage.getItem("author_or_not") === 'true';
  console.log(isAuthor,"isAuthor")
  const [error, setError] = useState(null);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const accessToken = localStorage.getItem("accessToken");
  
  const {
    cartItems,
    addToCart,
    removeProductByQuantityFromCart,
    finalizeCart,
  } = useContext(CartContext);
  const [key, setKey] = useState(0);
  console.log("Cart", cartItems);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const accessToken = localStorage.getItem("accessToken");
        if (accessToken) {
          const productsData = await fetchProducts(accessToken);
          const categoriesData = await fetchCategories(accessToken);
          setProducts(productsData);
          setCategories(categoriesData);
        }
      } catch (error) {
        setError("Failed to fetch products.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []); // Fetch products only once on component mount add [key] if reqd

  const handleRemoveFromCart = (product, quantity) => {
    // Logic to remove a specified quantity of product from the cart
    removeProductByQuantityFromCart(product, quantity);
    setKey((prevKey) => prevKey + 1); // Update key to trigger data refresh
  };
  const handleCloseError = () => {
    setError(null); // Clear the error when the user closes the notification
  };
  return (
    <div>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>{error}</p>
      ) : isLoggedIn ? (
        isAuthor ? (
          
          <div><Navbar toggleTheme={toggleTheme}
          isHome={true}
          handleLogout={handleLogout}

          // finalizeCart={finalizeCart} Authors can only sell
        />
        
        <h1>Welcome, Author!</h1>
        <AuthorProductUploadForm accessToken={accessToken} categories={categories}></AuthorProductUploadForm>
        
        <AuthorForm accessToken={accessToken}></AuthorForm>
        <br></br>
        </div>
        ) : (
          <div>
          <Navbar toggleTheme={toggleTheme}
            isHome={true}
            handleLogout={handleLogout}
            finalizeCart={finalizeCart}
          />
          
          
          <div className="product-grid">
            {products.map((product) => {
              const selectedProduct = cartItems.find(
                (item) => item.id === product.id
              );
              const quantity = selectedProduct ? selectedProduct.quantity : 0;
              return (
                
                <div key={product.id} className="product-item">
                  <h3>{product.name}</h3>

                  {product.image ? (
                    <Link to={`/products/${product.id}`}>
                      <img
                        src={BASE_URL + product.image}
                        alt={product.name}
                        className="product-image"
                      />
                    </Link>
                  ) : (
                    ""
                  )}
                  <ProductDescription description={product.longDescription} />
                  <p>Price: {product.price}</p>
                  <h3>{product.category.name}</h3>
                  {product.pdf && (
                    <a href={`${BASE_URL}${product.pdf.file}`} download>
                      <div className="button-container">
                        <button onClick={() => updateTrends(product)}>
                          <div className="circle">Download PDF</div>
                        </button>
                      </div>
                    </a>
                  )}

                  <div className="button-container">
                    <div className="circle">
                      <span>{`Selected :-${quantity}`}</span>
                    </div>

                    <div className="button-container">
                      <button
                        className="circle"
                        onClick={() => addToCart(product, 1)}
                      >
                        Add to Cart
                      </button>
                      {selectedProduct && (
                        <button
                          className="circle"
                          onClick={() => handleRemoveFromCart(product, 1)}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {error && (
            <ErrorNotification message={error} onClose={handleCloseError} />
          )}
        </div>
        )
      ) : (
        <div>{navigate("/login")}</div>
      )
      }
    </div>
  );
};

export default Home;
